module.exports = __webpack_public_path__ + "static/media/space-background.ef4546e4.jpg";